import { FC, useState, useEffect } from "react";
import cn from "classnames";

import { GridProps, GridContainerProps, GridItemProps } from "./Grid.props";
import styles from "./Grid.module.scss";

import { useWindowSize } from "../../hooks/windowSize";

/**
 * @deprecated Use `import { Grid } from capitalrx-components-2.0/lib/layout` instead.
 */
const GridContainer: FC<GridContainerProps> = (props: GridContainerProps) => {
  const { id, testId, container, children, className, justifyContent, alignItems, centered, fullWidth } = props;

  const gridWrapperClasses = cn(styles["grid_wrapper"], { [styles["centered"]]: centered }, { [styles["fullWidth"]]: fullWidth });

  const gridClasses = cn(
    styles["grid"],
    { [styles["grid_container"]]: container },
    { [styles[`grid_justify_${justifyContent}`]]: justifyContent },
    { [styles[`grid_align_${alignItems}`]]: alignItems },
    className,
  );

  return (
    <div className={gridWrapperClasses}>
      <div id={id} className={gridClasses} data-testid={testId ? `test__${testId}` : undefined}>
        {children}
      </div>
    </div>
  );
};

/**
 * @deprecated
 */
const GridItem: FC<GridItemProps> = (props: GridItemProps) => {
  const { id, testId, item, children, className, colSm, colMd, colLg } = props;
  const [windowSize, setWindowSize] = useState("desktop");

  const windowWidth = useWindowSize();

  useEffect(() => {
    if (colSm && windowWidth.width && windowWidth.width < 768) {
      setWindowSize("mobile");
    } else if (colMd && windowWidth.width && windowWidth.width >= 768 && windowWidth.width < 1040) {
      setWindowSize("tablet");
    } else {
      setWindowSize("desktop");
    }
  }, [windowWidth]);

  const gridClasses = cn(
    styles["grid"],
    { [styles["grid_item"]]: item },
    { [styles[`grid_item_columns_${colLg}`]]: colLg && windowSize === "desktop" },
    { [styles[`grid_item_columns_${colSm}`]]: colSm && windowSize === "mobile" },
    { [styles[`grid_item_columns_${colMd}`]]: colMd && windowSize === "tablet" },
    className,
  );

  return (
    <div id={id} className={gridClasses} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </div>
  );
};

/**
 * @deprecated
 */
const Grid: FC<GridProps> = (props: GridProps) => {
  const { id, testId, container, item, className, children, justifyContent, alignItems, centered, colSm, colMd, colLg, fullWidth } = props;

  if (container) {
    return (
      <GridContainer
        id={id}
        testId={testId}
        container
        justifyContent={justifyContent}
        alignItems={alignItems}
        centered={centered}
        className={className}
        fullWidth={fullWidth}
      >
        {children}
      </GridContainer>
    );
  }
  if (item) {
    return (
      <GridItem id={id} item testId={testId} colSm={colSm} colMd={colMd} colLg={colLg || 12} className={className}>
        {children}
      </GridItem>
    );
  }
  return null;
};

/**
 * @deprecated
 */
export default Grid;
